import { IntercomProvider } from 'react-use-intercom';

const Intercom = {}

export {
  Intercom,
  IntercomProvider
}
